import { jsx as a } from "react/jsx-runtime";
import { forwardRef as p } from "react";
import m from "@mui/material/FormHelperText";
import s from "styled-components";
const f = {
  root: "formHelperTextRoot",
  error: "formHelperTextError",
  disabled: "formHelperTextDisabled",
  marginDense: "formHelperMarginDense",
  contained: "formHelperContained",
  focused: "formHelperTextFocused",
  filled: "formHelperTextFilled",
  required: "formHelperTextRequired"
}, x = s(m).withConfig({
  displayName: "StyledMaterialUIFormHelperText"
})([
  "&&.formHelperTextRoot{width:100%;display:block;position:",
  ";white-space:",
  ";font-size:",
  ";color:",
  ";line-height:1.2em;margin:6px 0px 0px 0px;text-align:",
  ";}&&.formHelperTextRoot.formHelperTextError{color:",
  ";text-align:",
  ";}&&.formHelperTextRoot.formHelperTextDisabled{color:",
  ";}"
], ({ $helperTextOverlay: e }) => e ? "absolute" : "relative", ({ $helperTextOverlay: e }) => e ? "nowrap" : "normal", ({ theme: e }) => e.typography.body100.fontSize, ({ theme: e }) => e.text.primary, ({ $helperTextPosition: e }) => e === "left" ? "start" : "end", ({ theme: e }) => e.caution, ({ $errorTextPosition: e }) => e === "left" ? "start" : "end", ({ theme: e }) => e.secondaryDisabled), n = /* @__PURE__ */ p(({ classes: e, helperTextPosition: r = "left", helperTextOverlay: o = !1, errorTextPosition: t = "right", ...l }, i) => /* @__PURE__ */ a(x, {
  ...l,
  ref: i,
  classes: {
    ...f,
    ...e
  },
  $helperTextPosition: r,
  $helperTextOverlay: o,
  $errorTextPosition: t
}));
n.displayName = "FormHelperText";
export {
  n as default
};
